// 平台常量枚举
export const Platform = {
  JIYIBAO: 'jiyibao',     // 吉意宝 APP
  KUAIBAO: 'kuaibao',     // 快宝 APP
  WXWORK: 'wxwork',       // 企业微信
  WXA: 'wxa',             // 微信小程序 webview
  WEIXIN: 'weixin',       // 微信公众号 H5
  BROWSER: 'browser'      // 手机浏览器兜底
};
